module.exports = __webpack_public_path__ + "static/media/reg_online.fa5b07c8.jpg";